import appWithAI from '@devices/settings/device_settings/app_settings_temperature_with_ai.js';
import device_information from '@devices/settings/device_settings/device_information';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'ShellyBLUHTZB',
	friendly_name: 'BLU HT ZB',
	category: 'sensor',
	family: 'sensor',
	isPM: false,
	dashInfoLabels: 'sensor-ht',
	modes: {
		sensor: {
			availableViews: ['basic', 'advanced'],
			channels: 1,
			notifications: ['device_problem', 'lowBattery'],
			charts: true,
			dashInfoLabels: 'sensor-ht',
			bluetooth_settings: [
				{ title: 'zigbee', component: 'zigbee_ble', min_ver: '1.2.12' },
				{ title: 'security', component: 'security_ble' },
			],
			settings: [
				{
					title: 'sensor_settings',
					components: [{ title: 'temperature_unit', component: 'temperature_unit_g2' }],
				},
				appWithAI,
				share,
				{
					title: 'settings',
					components: [
						{
							title: 'temperature_offset',
							component: 'temperature_offset_ble',
							min_ver: '1.1.4',
						},
						{
							title: 'humidity_offset',
							component: 'humidity_offset_ble',
							min_ver: '1.1.4',
						},
						{ title: 'firmware_version', component: 'firmware_update_ble' },
						{ title: 'factory_reset', component: 'factory_reset_ble' },
					],
				},
				device_information,
			],
		},
	},
};
